import React from 'react';
import styles from './CalculatorSection.module.scss';
import CalculatorCalculation from '../../CalculatorCalculation/CalculatorCalculation';
import {
  openModal as openModalAction,
  RMD_CALCULATOR_DISCLAIMER,
} from '../../../../redux/modules/modals/modals.module';
import { useDispatch } from 'react-redux';
const CalculatorSection = () => {
  const dispatch = useDispatch();
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>Tell us about yourself</div>
      <div className={styles['sub-title']}>
        Enter the requested information and press the Calculate My RMD button to see
        your estimated distribution. Please note: Your RMD will need to be
        recalculated for each taxable year. This RMD calculator is not
        appropriate for calculating RMDs required by beneficiaries.
      </div>
      <div>
        <CalculatorCalculation />
      </div>
      <p className={styles['disclaimer']}>*Account Balance as of 12/31 of the previous year for which you are calculating the RMD. Additionally, be sure to adjust this balance to include any pending transfers or rollovers into this account.</p>
      <button
          className={styles['buttonBorder']}
          onClick={() => dispatch(openModalAction(RMD_CALCULATOR_DISCLAIMER))}
      >
        RMD Calculator Important Information
      </button>
    </div>
  );
};

export default CalculatorSection;
